import { create } from "zustand"
import { subscribeWithSelector } from "zustand/middleware"

export default create(subscribeWithSelector((set) =>
{
    return {

        thruster: 'null',
        phase: 'standard',
        touch: 'false',
        infoPanel: 'null',
        orientation: 'notset',
        highlight: 'null',

        het: ()=>
            {
                set((state)=>
                {
                    return { thruster: 'HET' } 
                })
            },

        mpt: ()=>
            {
                set((state)=>
                {
                    return { thruster: 'MPT' } 
                })
            },

        bpt: ()=>
            {
                set((state)=>
                {
                    return { thruster: 'BPT' } 
                })
            },

        cgt: ()=>
            {
                set((state)=>
                {
                    return { thruster: 'CGT' } 
                })
            },

        reset: ()=>
            {
                set((state) => {
                    // Renumbered and cleaned up panel references
                    const panelIds = [
                        'S_FD',  // 1
                        'S_PR',  // 2
                        'S_PS',  // 3
                        'C_FM',  // 4
                        'C_FI',  // 5
                        'C_SS',  // 6
                        'C_FP',  // 7
                        'C_PR1', // 8
                        'C_PR2', // 9
                        'C_CP',  // 10
                        'C_FD1', // 11
                        'C_FD2', // 12
                        'C_SF1', // 13
                        'C_SF2', // 14
                        'C_IV1', // 15
                        'C_IV2', // 16
                        'C_NZ',  // 17
                        'C_TO'   // 18
                    ];

                    panelIds.forEach(id => {
                        const panel = document.getElementById(id);
                        if (!panel) return;
                        if (panel.classList.contains('show')) {
                            panel.classList.add('hide');
                        }
                        panel.classList.remove('show');
                    });

                    return { infoPanel: 'null' };
                });
                
            },

        h_ps: ()=>
            {
                set((state)=>
                {
                    return { highlight: 'h_ps' } 
                })
            },

        h_fd: ()=>
            {
                set((state)=>
                {
                    return { highlight: 'h_fd' } 
                })
            },

        h_pr: ()=>
            {
                set((state)=>
                {
                    return { highlight: 'h_pr' } 
                })
            },

        h_null: ()=>
            {
                set((state)=>
                {
                    return { highlight: 'null' } 
                })
            },

            
        s_fd: ()=>
            {
            set((state)=>
                {
                    {
                    state.reset()
                    var panel = document.getElementById('S_FD')
                    panel.classList.remove('hide')
                    panel.classList.add('show')
                    
                    return { infoPanel: 'S_FD' }
                }
            })
            
        },

        s_pr: ()=>
        {
            set((state)=>
            {
                {
                    state.reset()
                    var panel = document.getElementById('S_PR')
                    panel.classList.remove('hide')
                    panel.classList.add('show')
                    
                    return { infoPanel: 'S_PR' }
                }
            })
            
        },
        
        s_ps: ()=>
        {
            set((state)=>
            {
                {
                    state.reset()
                    var panel = document.getElementById('S_PS')
                    panel.classList.remove('hide')
                    panel.classList.add('show')
                    
                    return { infoPanel: 'S_PS' }
                }
            })
            
        },
        
        c_fm: ()=>
        {
            set((state)=>
            {
                {
                    state.reset()
                    var panel = document.getElementById('C_FM')
                    panel.classList.remove('hide')
                    panel.classList.add('show')
                    
                    return { infoPanel: 'C_FM' }
                }
            })
            
        },
        
        c_fi: ()=>
        {
            set((state)=>
            {
                {
                    state.reset()
                    var panel = document.getElementById('C_FI')
                    panel.classList.remove('hide')
                    panel.classList.add('show')
                    
                    return { infoPanel: 'C_FI' }
                }
            })
            
        },
        
        c_ss: ()=>
        {
            set((state)=>
                {
                {
                    state.reset()
                    var panel = document.getElementById('C_SS')
                    panel.classList.remove('hide')
                    panel.classList.add('show')
                    
                    return { infoPanel: 'C_SS' }
                }
            })
            
        },
        
        c_fp: ()=>
        {
            set((state)=>
            {
                {
                    state.reset()
                    var panel = document.getElementById('C_FP')
                    panel.classList.remove('hide')
                    panel.classList.add('show')
                    
                    return { infoPanel: 'C_FP' }
                }
            })
            
        },
        
        c_pr1: ()=>
        {
            set((state)=>
            {
                {
                    state.reset()
                    var panel = document.getElementById('C_PR1')
                    panel.classList.remove('hide')
                    panel.classList.add('show')
                    
                    return { infoPanel: 'C_PR1' }
                }
            })
        },
        
        c_pr2: ()=>
            {
            set((state)=>
            {
                {
                    state.reset()
                    var panel = document.getElementById('C_PR2')
                    panel.classList.remove('hide')
                    panel.classList.add('show')
                    
                    return { infoPanel: 'C_PR2' }
                }
            })
        },
        
        c_cp: ()=>
        {
            set((state)=>
            {
                {
                    state.reset()
                    var panel = document.getElementById('C_CP')
                    panel.classList.remove('hide')
                    panel.classList.add('show')
                    
                    return { infoPanel: 'C_CP' }
                }
            })
            
        },
        
        c_fd1: ()=>
        {
            set((state)=>
            {
                {
                    state.reset()
                    var panel = document.getElementById('C_FD1')
                    panel.classList.remove('hide')
                    panel.classList.add('show')
                    
                    return { infoPanel: 'C_FD1' }
                }
            })
        },

        c_fd2: ()=>
        {
            set((state)=>
            {
                {
                    state.reset()
                    var panel = document.getElementById('C_FD2')
                    panel.classList.remove('hide')
                    panel.classList.add('show')
                    
                    return { infoPanel: 'C_FD2' }
                }
            })
        },
        
        
        c_sf1: ()=>
        {
            set((state)=>
            {
                {
                    state.reset()
                    var panel = document.getElementById('C_SF1')
                    panel.classList.remove('hide')
                    panel.classList.add('show')
                    
                    return { infoPanel: 'C_SF1' }
                }
            })
        },
        
        c_sf2: ()=>
        {
            set((state)=>
            {
                {
                    state.reset()
                    var panel = document.getElementById('C_SF2')
                    panel.classList.remove('hide')
                    panel.classList.add('show')
                    
                    return { infoPanel: 'C_SF2' }
                }
            })
        },
        
        c_iv1: ()=>
        {
            set((state)=>
            {
                {
                    state.reset()
                    var panel = document.getElementById('C_IV1')
                    panel.classList.remove('hide')
                    panel.classList.add('show')
                    
                    return { infoPanel: 'C_IV1' }
                }
            })
            
        },
        
        c_iv2: ()=>
        {
            set((state)=>
            {
                {
                    state.reset()
                    var panel = document.getElementById('C_IV2')
                    panel.classList.remove('hide')
                    panel.classList.add('show')
                    
                    return { infoPanel: 'C_IV2' }
                }
            })
            
        },
        
        c_to: ()=>
        {
            set((state)=>
            {
                {
                    state.reset()
                    var panel = document.getElementById('C_TO')
                    panel.classList.remove('hide')
                    panel.classList.add('show')
                    
                    return { infoPanel: 'C_TO' }
                }
            })
            
        },
        
        c_nz: ()=>
        {
            set((state)=>
            {
                {
                    state.reset()
                    var panel = document.getElementById('C_NZ')
                    panel.classList.remove('hide')
                    panel.classList.add('show')
                    
                    return { infoPanel: 'C_NZ' }
                }
            })
            
        },

        landscape: ()=>
            {
                set((state)=>
                {
                    return { orientation: 'landscape' } 
                })
            },

        portrait: ()=>
            {
                set((state)=>
                {   
                    return { orientation: 'portrait' }
                })
            },

        zoom: ()=>
            {
                set((state)=>
                {
                    if(state.phase === 'standard')
                        {
                            return { phase: 'zoomed' }
                            
                        }

                    if(state.phase === 'zoomed')
                        {
                            return { phase: 'standard' } 
                        }
                            
                    return {}
                })
            },

        touched: ()=>
            {
                set((state)=>
                {   
                    
                        {
    
                            return { touch: 'true' }       
                        }
                                    
                })
            },
        }
}))